import { render } from "./q8.vue?vue&type=template&id=4038b48e&scoped=true"
import script from "./q8.vue?vue&type=script&lang=js"
export * from "./q8.vue?vue&type=script&lang=js"

import "./q8.vue?vue&type=style&index=0&id=4038b48e&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4038b48e"],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionTemplates/q8.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4038b48e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4038b48e', __exports__)) {
    api.reload('4038b48e', __exports__)
  }
  
  module.hot.accept("./q8.vue?vue&type=template&id=4038b48e&scoped=true", () => {
    api.rerender('4038b48e', render)
  })

}


export default __exports__